interface IRegexProps {
  nameFilter: RegExp;
  phoneFilter: RegExp;
  emailFilter: RegExp;
  descriptionFilter: RegExp;
}

const REGEX: IRegexProps = {
  nameFilter: /[^a-zA-Z .,‘’'-]/gi,
  emailFilter: /[^a-zA-Z0-9 !#$%&'*+-/=?^_`{|}~.@]/gi,
  phoneFilter: /[^a-zA-Z0-9 .:;,"“”'‘’()!?+/-]/gi,
  descriptionFilter: /[^a-zA-Z0-9 .:;,@=$%^&"“”'‘’()!?+/-]/gi,
};

export const sanitizeName = (value: string): string => {
  return value.replaceAll(REGEX.nameFilter, "");
};

export const sanitizeEmail = (value: string): string => {
  return value.replaceAll(REGEX.emailFilter, "");
};

export const sanitizePhone = (value: string): string => {
  return value.replaceAll(REGEX.phoneFilter, "");
};

export const sanitizeDescription = (value: string): string => {
  return value.replaceAll(REGEX.descriptionFilter, "");
};
